import React from 'react';
import { addMessage, appendToMessage, setStatus } from '../../redux/actions/ai.actions';
import { chat } from '../../api/coachAIAPI';
import { useDispatch, useSelector } from 'react-redux';
import { filter, last } from 'lodash';
import { isQuestion } from '../../utils/Chat/ChatUtil';

export function useChat() {
  const messages = useSelector((s) => s.ai.messages);
  const dispatch = useDispatch();

  const typewriteAnswer = React.useCallback(
    (id, fullText, cps = 40) => {
      const intervalMs = 1000 / cps;
      let i = 0;
      const timer = setInterval(() => {
        const step = Math.max(1, Math.floor(cps / 10));
        const next = fullText.slice(i, i + step);
        i += step;
        if (next) dispatch(appendToMessage({ id, chunk: next }));
        if (i >= fullText.length) {
          clearInterval(timer);
          dispatch(setStatus({ id, status: 'sent' }));
        }
      }, intervalMs);
      return () => clearInterval(timer);
    },
    [dispatch]
  );

  const sendQuestion = async (text, options) => {
    const qId = crypto.randomUUID();

    dispatch(
      addMessage({
        id: qId,
        type: 'Question',
        content: text,
        createdAt: Date.now(),
        status: 'sent',
        hide: options && options.hide === true
      })
    );

    const aId = crypto.randomUUID();
    dispatch(
      addMessage({
        id: aId,
        type: 'Answer',
        content: '',
        createdAt: Date.now(),
        status: 'pending'
      })
    );
    try {
      const responseText = await chat(text);
      if (!responseText || !responseText.data) {
        dispatch(setStatus({ id: aId, status: 'error' }));
        return;
      }
      typewriteAnswer(aId, responseText.data);
    } catch (error) {
      dispatch(setStatus({ id: aId, status: 'error' }));
    }
  };

  const retryQuestion = async () => {
    const questions = filter(messages, (m) => isQuestion(m));
    if (!questions.length) return;
    sendQuestion(last(questions).content, { hide: last(questions).hide });
  };

  return { messages, sendQuestion, retryQuestion };
}
